module.exports = __webpack_public_path__ + "img/huo.90ff985f.png";